import React from "react";
import PropTypes from "prop-types";

/**
 * load_data component 单选下拉渲染器。完全 schema 驱动:
 * - 渲染 fields[0](必须是 type=select);选项来自 fields[0].options
 * - 多渲染一行"💡 下游节点将依据此数据源提取的行数进行自动循环遍历。"
 * - 数据:componentData[component.name],通过 values prop 传入
 * - 写入:onChange(key, value) → onComponentValueChange
 */
function DataSourceTarget({ fields, values, isEdit = true, onChange }) {
  if (!fields || fields.length === 0) return null;
  const f = fields[0];
  if (f.type !== "select") return null;
  const current = values?.[f.key] ?? "";
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <select
        className="tfe-form-control"
        value={current}
        disabled={!isEdit}
        onChange={(e) => onChange(f.key, e.target.value)}
      >
        {(f.options || []).map((o) => (
          <option key={o.value} value={o.value}>{o.name}</option>
        ))}
      </select>
      <div style={{ fontSize: "12px", color: "#64748b", display: "flex", gap: "6px" }}>
        <span style={{ color: "#f59e0b" }}>💡</span>
        提示:下游节点将依据此数据源提取的行数进行自动循环遍历。
      </div>
    </div>
  );
}

DataSourceTarget.propTypes = {
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      type: PropTypes.oneOf(["select"]).isRequired,
      options: PropTypes.array,
    })
  ),
  values: PropTypes.object,
  isEdit: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

export default DataSourceTarget;